export default __webpack_public_path__ + "static/media/indique.9250528e.png";